import Navbar from "ui/navbar";
import BannerImg from "assets/png/banner-img.png";
import { useModal } from "context/modal-context";

const services = [
  {
    label: "Software Engineers",
    delay: "0s",
    top: "-6%", left: "4%",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M8 3L3 12l5 9M16 3l5 9-5 9M14 5l-4 14" stroke="#3B4A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    label: "Product Managers",
    delay: "0.7s",
    top: "-4%", right: "4%",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="18" height="18" rx="3" stroke="#3B4A6B" strokeWidth="2"/>
        <path d="M8 8h8M8 12h5M8 16h6" stroke="#3B4A6B" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    label: "Cloud & DevOps",
    delay: "1.3s",
    top: "32%", left: "-4%",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M18 10a6 6 0 10-11.83 1.5A4 4 0 106 18h12a4 4 0 000-8z" stroke="#3B4A6B" strokeWidth="2" strokeLinejoin="round"/>
        <path d="M12 14v4M10 16l2 2 2-2" stroke="#3B4A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    label: "Data Analysts",
    delay: "0.4s",
    top: "25%", right: "-2%",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M4 20V14M8 20V10M12 20V4M16 20V12M20 20V8" stroke="#3B4A6B" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    label: "AI/ML Engineers",
    delay: "1.9s",
    bottom: "28%", left: "-2%",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="3" stroke="#3B4A6B" strokeWidth="2"/>
        <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5.64 5.64l2.12 2.12M16.24 16.24l2.12 2.12M5.64 18.36l2.12-2.12M16.24 7.76l2.12-2.12" stroke="#3B4A6B" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    label: "Quality Assurance",
    delay: "1.1s",
    bottom: "10%", left: "10%",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z" stroke="#3B4A6B" strokeWidth="2" strokeLinejoin="round"/>
        <path d="M9 12l2 2 4-4" stroke="#3B4A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    label: "UI/UX Designers",
    delay: "0.6s",
    bottom: "22%", right: "-2%",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="#3B4A6B" strokeWidth="2"/>
        <path d="M8 12a4 4 0 008 0" stroke="#3B4A6B" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="9" cy="9" r="1" fill="#3B4A6B"/>
        <circle cx="15" cy="9" r="1" fill="#3B4A6B"/>
      </svg>
    ),
  },
  {
    label: "Developers",
    delay: "2.1s",
    top: "58%", right: "-4%",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M16 18l6-6-6-6M8 6L2 12l6 6" stroke="#3B4A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
];

const Hero = () => {
  const { openModal } = useModal();

  return (
    <div className="w-full min-h-screen bg-[#080B1F] flex flex-col">
      <Navbar />

      <div className="flex-1 relative flex flex-col xl:flex-row items-center justify-between px-6 sm:px-10 xl:px-20 pt-8 xl:pt-12 pb-16 gap-8 xl:gap-4">

        {/* Left: Text & CTA */}
        <div data-aos="fade-up" data-aos-duration="800" className="flex flex-col gap-6 w-full xl:max-w-[580px] z-10" style={{ animation: "floatText 5s ease-in-out infinite" }}>
          <h1 className="text-[36px] sm:text-[44px] md:text-[52px] xl:text-[60px] leading-[1.1] font-black text-white">
            Building{" "}
            <span className="text-yellow-100" style={{ animation: "glowPulse 3s ease-in-out infinite" }}>Africa's</span>
            <br className="hidden sm:block" />
            {" "}Technology
            <br />
            Workforce and
            <br />
            Delivery Capacity.
          </h1>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mt-2">
            <button
              onClick={() => openModal("hire-talent")}
              className="flex items-center justify-center gap-2.5 px-7 py-3.5 bg-yellow-100 text-blue-100 font-semibold rounded-full hover:bg-yellow-200 transition-all"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="currentColor"/>
              </svg>
              Hire Tech Talent
            </button>

            <a
              href="https://stacstart.com/courses"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2.5 px-7 py-3.5 bg-[rgba(255,255,255,0.08)] text-white font-semibold rounded-full border border-white/25 hover:bg-[rgba(255,255,255,0.15)] transition-all"
            >
              Learn a Tech skill
            </a>
          </div>
        </div>

        {/* Right: Banner Image + Floating Cards */}
        <div data-aos="fade-up" data-aos-duration="800" data-aos-delay="100" className="flex items-center justify-center xl:justify-end w-full xl:flex-1">
          <div className="relative" style={{ perspective: "900px" }}>
            {services.map((s) => (
              <span
                key={s.label}
                className="absolute flex items-center gap-2 px-3 py-2 text-[#1E2A45] text-xs sm:text-sm font-semibold select-none pointer-events-none z-20 whitespace-nowrap"
                style={{
                  background: "rgba(255,255,255,0.96)",
                  borderRadius: "14px",
                  border: "1px solid rgba(200,210,230,0.6)",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.1)",
                  top: s.top,
                  bottom: (s as any).bottom,
                  left: (s as any).left,
                  right: (s as any).right,
                  animation: `floatPill 4.5s ease-in-out ${s.delay} infinite`,
                }}
              >
                {s.icon}
                {s.label}
              </span>
            ))}
            <img
              src={BannerImg}
              alt="Technology illustration"
              className="w-full max-w-[420px] sm:max-w-[500px] xl:max-w-[640px] object-contain drop-shadow-2xl"
              style={{ animation: "zoomPulse 6s ease-in-out infinite" }}
            />
          </div>
        </div>

        <style>{`
          @keyframes zoomPulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.07); }
          }
          @keyframes floatText {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
          @keyframes glowPulse {
            0%, 100% { text-shadow: 0 0 8px rgba(255, 233, 105, 0.3); }
            50% { text-shadow: 0 0 24px rgba(255, 233, 105, 0.9), 0 0 48px rgba(255, 233, 105, 0.4); }
          }
          @keyframes floatPill {
            0%   { transform: translateY(0px)    rotateZ(-4deg)  rotateY(0deg); }
            20%  { transform: translateY(-10px)  rotateZ(3deg)   rotateY(18deg); }
            40%  { transform: translateY(-18px)  rotateZ(-5deg)  rotateY(-14deg); }
            60%  { transform: translateY(-11px)  rotateZ(4deg)   rotateY(22deg); }
            80%  { transform: translateY(-5px)   rotateZ(-3deg)  rotateY(-8deg); }
            100% { transform: translateY(0px)    rotateZ(-4deg)  rotateY(0deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Hero;
